// Module
var code = "<input type=\"checkbox\" ng-model=\"$ctrl.isAutoSaveEnabled\" ng-change=\"$ctrl.isAutoSaveEnabledChanged()\"> {{\"AUTO_SAVE.AUTOSAVE_IN\" | translate}} {{$ctrl.secoundUntilCall}} {{\"AUTO_SAVE.SECONDS\" | translate}}";
// Exports
module.exports = code;